import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getMyBizList } from '@/api/cmdb';
import store from '@/store/index';
import { getCurrentBiz } from '@/utils/bizHelper';
export default {
  name: 'BizList',
  data: function data() {
    return {
      bizList: [],
      listData: []
    };
  },
  computed: _objectSpread({}, mapGetters(['currBiz'])),
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var results;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return getMyBizList({
              system: 'job'
            });
          case 1:
            results = _context.v;
            this.bizList = results;
            this.listData = results;

            // 页面刷新时，确保业务下拉框与URL中的业务代码一致
            this.syncWithUrlBizCode();
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    changeCurrBiz: function changeCurrBiz(value) {
      // 找到对应的业务信息
      var selectedBiz = this.bizList.find(function (biz) {
        return biz.id === value;
      });
      if (selectedBiz) {
        // 更新业务ID和业务代码
        store.commit('profile/SET_CURR_BIZ', value);
        store.commit('profile/SET_CURR_BIZ_CODE', selectedBiz.code);
        store.commit('profile/SET_CURR_BIZ_NAME', selectedBiz.name);

        // 获取当前路由路径
        var currentPath = this.$router.currentRoute.fullPath;

        // 构建新的路径，替换业务代码部分
        var newPath;
        if (currentPath.includes('/biz/')) {
          // 如果当前路径已经包含业务代码，则替换它
          // 处理两种情况：实际的业务代码和未替换的 :biz_code 参数
          if (currentPath.includes('/biz/:biz_code')) {
            newPath = currentPath.replace('/biz/:biz_code', "/biz/".concat(selectedBiz.code));
          } else {
            newPath = currentPath.replace(/\/biz\/[^/]+/, "/biz/".concat(selectedBiz.code));
          }
        } else {
          // 否则重定向到该业务的首页
          newPath = "/biz/".concat(selectedBiz.code, "/index");
        }

        // 保存业务信息到 sessionStorage
        sessionStorage.setItem('currBiz', value);
        sessionStorage.setItem('currBizCode', selectedBiz.code);
        sessionStorage.setItem('currBizName', selectedBiz.name);

        // 跳转到新路径
        this.$router.replace(newPath);
      }
    },
    /**
     * 与URL中的业务代码同步
     * 确保业务下拉框显示的业务与URL中的业务代码一致
     */
    syncWithUrlBizCode: function syncWithUrlBizCode() {
      // 从URL中获取业务代码
      var route = this.$router.currentRoute;
      if (route.params && route.params.biz_code && route.params.biz_code !== ':biz_code') {
        var urlBizCode = route.params.biz_code;

        // 查找对应的业务信息
        var selectedBiz = this.bizList.find(function (biz) {
          return biz.code === urlBizCode;
        });
        if (selectedBiz) {
          // 更新业务信息
          store.commit('profile/SET_CURR_BIZ', selectedBiz.id);
          store.commit('profile/SET_CURR_BIZ_NAME', selectedBiz.name);
          store.commit('profile/SET_CURR_BIZ_CODE', selectedBiz.code);

          // 更新 sessionStorage
          sessionStorage.setItem('currBiz', selectedBiz.id);
          sessionStorage.setItem('currBizCode', selectedBiz.code);
          sessionStorage.setItem('currBizName', selectedBiz.name);

          // 更新业务上下文
          if (this.$bizContext) {
            this.$bizContext.switchBiz(selectedBiz.code);
          }
          console.log("[BizList] Synchronized with URL business code: ".concat(urlBizCode));
        } else {
          console.warn("[BizList] Business code ".concat(urlBizCode, " from URL not found in business list"));
        }
      } else {
        // 如果URL中没有业务代码，则使用getCurrentBiz获取
        this.getCurrBizName();
      }
    },
    /**
     * 获取当前业务信息
     * 用于URL中没有业务代码的情况
     */
    getCurrBizName: function getCurrBizName() {
      var _this = this;
      // 获取当前业务信息
      var _getCurrentBiz = getCurrentBiz(),
        bizId = _getCurrentBiz.bizId,
        bizCode = _getCurrentBiz.bizCode;
      console.log("[BizList] Getting current business: ID=".concat(bizId, ", Code=").concat(bizCode));
      if (this.bizList && this.bizList.length > 0) {
        // 如果已经有业务列表，直接使用
        var selectedBiz = this.bizList.find(function (item) {
          return item.id === bizId || item.code === bizCode;
        });
        if (selectedBiz) {
          // 更新业务信息
          store.commit('profile/SET_CURR_BIZ', selectedBiz.id);
          store.commit('profile/SET_CURR_BIZ_NAME', selectedBiz.name);
          store.commit('profile/SET_CURR_BIZ_CODE', selectedBiz.code);

          // 更新 sessionStorage
          sessionStorage.setItem('currBiz', selectedBiz.id);
          sessionStorage.setItem('currBizCode', selectedBiz.code);
          sessionStorage.setItem('currBizName', selectedBiz.name);
          console.log("[BizList] Updated current business: ".concat(selectedBiz.name, "(").concat(selectedBiz.code, ")"));
        } else {
          console.warn("[BizList] Business ID=".concat(bizId, ", Code=").concat(bizCode, " not found in business list"));
        }
      } else {
        // 如果还没有业务列表，从API获取
        getMyBizList({
          system: 'job'
        }).then(function (data) {
          _this.bizList = data;
          _this.listData = data;
          var selectedBiz = data.find(function (item) {
            return item.id === bizId || item.code === bizCode;
          });
          if (selectedBiz) {
            // 更新业务信息
            store.commit('profile/SET_CURR_BIZ', selectedBiz.id);
            store.commit('profile/SET_CURR_BIZ_NAME', selectedBiz.name);
            store.commit('profile/SET_CURR_BIZ_CODE', selectedBiz.code);

            // 更新 sessionStorage
            sessionStorage.setItem('currBiz', selectedBiz.id);
            sessionStorage.setItem('currBizCode', selectedBiz.code);
            sessionStorage.setItem('currBizName', selectedBiz.name);
            console.log("[BizList] Updated current business from API: ".concat(selectedBiz.name, "(").concat(selectedBiz.code, ")"));
          } else {
            console.warn("[BizList] Business ID=".concat(bizId, ", Code=").concat(bizCode, " not found in API business list"));
          }
        });
      }
    },
    handleFilter: function handleFilter(value) {
      this.listData = this.bizList.filter(function (o) {
        return o.name.includes(value) || o.code.includes(value) || o.id === parseInt(value);
      });
    }
  }
};